module.exports = __webpack_public_path__ + "static/media/sfyg-linking-messaging.4ad7074b.png";